import { IProductDTO } from '@legacy/shared-types/dto/product.type';
import { ProductTypeEnum } from '@legacy/shared-types/enums/product-type.enum';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { productApi } from '@api/product/productsApi';
import { IProductDataTransformed } from './types';

export const useProductsList = (): UseQueryResult<IProductDataTransformed[]> =>
  useQuery(['products-list'], productApi.getProducts, {
    select: (fetchedData): IProductDataTransformed[] => {
      const { data: productList, status } = fetchedData;
      if (status !== 200) return [];

      return productList.map((product: IProductDTO) => ({
        ...product,
        code: product.salesforceId,
        initialMargin: product.productType === ProductTypeEnum.DISCOUNT ? product.initialMargin : 0,
        initialRate: product.initialBaseRate + product.initialMargin,
      }));
    },
  });
